import {
  HiddenForPermission,
  MobileTableConteiner,
  PaginationMobile,
  SkeletonMobile,
  TableMobileButton,
  TableMobileCell,
  TableMobileContent,
  TableMobileItem,
  TableMobileTitle
} from '../../../../../../components';
import { goToEditSegment } from '../../../../../../router/coordinator';

export function MobileTable({ segments, loading, count, page, offset, handlePage, navigate }) {
  const sectorsList = segments?.map((sector) => {
    return (
      <TableMobileCell key={sector.uuid}>
        <TableMobileItem>
          <TableMobileTitle>Nome </TableMobileTitle>
          <TableMobileContent>{sector.title?.toTitleCase()}</TableMobileContent>
        </TableMobileItem>

        <HiddenForPermission keys="EDIT_SEGMENT">
          <TableMobileButton onClick={() => goToEditSegment(navigate, sector.uuid)}>
            Editar
          </TableMobileButton>
        </HiddenForPermission>
      </TableMobileCell>
    );
  });

  return (
    <MobileTableConteiner>
      {!loading ? sectorsList : <SkeletonMobile numbersOfColumns={10} />}
      <PaginationMobile count={count} page={page} rowsPerPage={offset} handlePage={handlePage} />
    </MobileTableConteiner>
  );
}
